var _defs, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _path6, _path7, _circle3, _path8, _path9, _path10, _path11, _path12, _path13, _circle4, _circle5, _circle6, _circle7, _path14, _path15, _path16, _path17, _polygon, _path18, _path19, _rect, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 261.49 65.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eb4b47;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Veri Smart Logo Vector") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.11,24.55a2.56,2.56,0,1,0,2.56,2.56A2.56,2.56,0,0,0,15.11,24.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.11,36.28a2.56,2.56,0,1,0,2.56,2.56A2.56,2.56,0,0,0,15.11,36.28Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.11,12.82a2.56,2.56,0,1,0,2.56,2.56A2.56,2.56,0,0,0,15.11,12.82Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.88,17.93a2.56,2.56,0,1,0-2.56-2.55A2.55,2.55,0,0,0,26.88,17.93Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.64,17.93a2.56,2.56,0,1,0-2.56-2.55A2.55,2.55,0,0,0,38.64,17.93Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.88,
    cy: 8.75,
    r: 1.27
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.64,
    cy: 8.75,
    r: 1.27
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.88,55.92a1.27,1.27,0,1,0,1.27,1.27A1.27,1.27,0,0,0,26.88,55.92Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.64,55.92a1.27,1.27,0,1,0,1.27,1.27A1.27,1.27,0,0,0,38.64,55.92Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.54,
    cy: 38.85,
    r: 1.27
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.54,25.82a1.27,1.27,0,1,0,1.27,1.27A1.27,1.27,0,0,0,8.54,25.82Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57,37.58a1.27,1.27,0,1,0,1.27,1.27A1.27,1.27,0,0,0,57,37.58Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57,25.82a1.27,1.27,0,1,0,1.27,1.27A1.27,1.27,0,0,0,57,25.82Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.4,12.82A2.56,2.56,0,1,0,53,15.38,2.56,2.56,0,0,0,50.4,12.82Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.4,24.55A2.56,2.56,0,1,0,53,27.11,2.56,2.56,0,0,0,50.4,24.55Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.4,36.28A2.56,2.56,0,1,0,53,38.84,2.56,2.56,0,0,0,50.4,36.28Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 39.38,
    cy: 26.37,
    r: 4.44,
    transform: "translate(-5 9.75) rotate(-13.28)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.3,
    cy: 26.37,
    r: 4.44,
    transform: "translate(-10.94 26.32) rotate(-45)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 39.38,
    cy: 39.41,
    r: 4.44,
    transform: "translate(-16.33 39.39) rotate(-45)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.3,
    cy: 39.41,
    r: 4.44,
    transform: "translate(-8.35 7.1) rotate(-13.28)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.11,48a2.56,2.56,0,1,0,2.56,2.56A2.56,2.56,0,0,0,15.11,48Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.88,48a2.56,2.56,0,1,0,2.55,2.56A2.56,2.56,0,0,0,26.88,48Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.64,48a2.56,2.56,0,1,0,2.55,2.56A2.56,2.56,0,0,0,38.64,48Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.4,48A2.56,2.56,0,1,0,53,50.57,2.56,2.56,0,0,0,50.4,48Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "84.99 44.37 74.91 18.66 71.56 18.66 83.27 47.81 86.67 47.81 98.39 18.66 95.11 18.66 84.99 44.37"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.87,28.94a9.33,9.33,0,0,0-5.12-1.36,9,9,0,0,0-5,1.44,9.31,9.31,0,0,0-3.48,3.8A10.78,10.78,0,0,0,102.39,43a9.31,9.31,0,0,0,3.6,3.76,10,10,0,0,0,5.16,1.4,9.76,9.76,0,0,0,5.44-1.6,7.92,7.92,0,0,0,3.24-4.44l-2.56-.8a6,6,0,0,1-6.16,4.24,6.79,6.79,0,0,1-4.92-2,6.94,6.94,0,0,1-2.2-4.84h16.08c0-.44,0-.76,0-1a12,12,0,0,0-1-5.23A8.07,8.07,0,0,0,115.87,28.94ZM104,36.29a7.33,7.33,0,0,1,2.28-4.35,6.23,6.23,0,0,1,4.44-1.8,6,6,0,0,1,4.44,1.68,7.33,7.33,0,0,1,2,4.47Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.07,28A7.68,7.68,0,0,0,128,31.86V27.94h-2.84V47.81h2.92V38.09c0-3.51,1.48-7.39,6.2-7.39a4.92,4.92,0,0,1,1.12.08V27.7a3,3,0,0,0-1-.08A6.81,6.81,0,0,0,132.07,28Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 139.59,
    y: 27.94,
    width: 2.92,
    height: 19.88
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M141.07,18.62a2.21,2.21,0,0,0-1.56.64,2.22,2.22,0,0,0,0,3.12,2.21,2.21,0,0,0,1.56.64,2.2,2.2,0,0,0,0-4.4Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.11,34.21a11,11,0,0,0-5.68-2.55l-3.68-.72c-2.84-.57-4.24-2.36-4.24-4.6,0-3,3-5.24,6.12-5.16,4.52,0,6.4,3,6.88,5l2.8-.88c-.6-3.12-3.36-7-9.64-7a10.65,10.65,0,0,0-4.52,1,8.48,8.48,0,0,0-3.4,2.88,7.24,7.24,0,0,0-1.32,4.28,6.68,6.68,0,0,0,2,5,8.3,8.3,0,0,0,2.4,1.64,12.09,12.09,0,0,0,2.56.84l3.84.76a8.54,8.54,0,0,1,2.76,1,4.63,4.63,0,0,1,2.44,4.16,4.77,4.77,0,0,1-2,4A7.66,7.66,0,0,1,158,45.21a7.17,7.17,0,0,1-4.8-1.8,7.28,7.28,0,0,1-2.64-4.36l-2.88.8a9.17,9.17,0,0,0,3.2,5.68A11,11,0,0,0,158,48.09c5.4.12,9.72-3.4,9.68-8.52a7.28,7.28,0,0,0-.6-2.68A7.58,7.58,0,0,0,165.11,34.21Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.91,27.58a7.87,7.87,0,0,0-7,4,6.66,6.66,0,0,0-6.36-4c-2.84,0-4.72,1.24-6.44,3.79V27.94h-2.84V47.81h2.92V36.49a6.84,6.84,0,0,1,1.48-4.44,4.94,4.94,0,0,1,4-1.83,4.68,4.68,0,0,1,3.84,1.64,6.92,6.92,0,0,1,1.28,4.27V47.81h2.84V36.37A6.46,6.46,0,0,1,191.19,32a4.93,4.93,0,0,1,4-1.8,4.63,4.63,0,0,1,3.88,1.68,6.76,6.76,0,0,1,1.28,4.35V47.81h2.88V35.53a8.49,8.49,0,0,0-1.88-5.75A6.88,6.88,0,0,0,195.91,27.58Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.67,35a8.12,8.12,0,0,0-.6-3.27c-1.2-2.76-3.6-4.12-7.24-4.12a8.91,8.91,0,0,0-5.28,1.64,7.25,7.25,0,0,0-2.8,4.4l2.8.59A4.91,4.91,0,0,1,213,31.49a5.38,5.38,0,0,1,3.76-1.31c3.32,0,5.08,1.64,5.08,4.83v1.32h-5.52c-3.56,0-7.88,1.44-7.88,5.76v.2a5.33,5.33,0,0,0,1.88,4.2,6.82,6.82,0,0,0,4.8,1.68,7.66,7.66,0,0,0,6.72-3.84,19.64,19.64,0,0,0,.28,3.48H225a60.11,60.11,0,0,1-.32-7.24Zm-2.84,4.44a6,6,0,0,1-1.76,4.44,6.16,6.16,0,0,1-4.44,1.76,4.69,4.69,0,0,1-3-1,3,3,0,0,1-1.24-2.6A2.8,2.8,0,0,1,213,39.41a7.36,7.36,0,0,1,3.24-.68h5.56Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238,28a7.68,7.68,0,0,0-4.08,3.84V27.94H231V47.81H234V38.09c0-3.51,1.48-7.39,6.2-7.39a4.92,4.92,0,0,1,1.12.08V27.7a3,3,0,0,0-1-.08A6.81,6.81,0,0,0,238,28Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.23,30.49V27.94h-5V22.22h-2.88v5.72h-3.68v2.55h3.68V42.65c0,2.92,1.32,5.32,5.64,5.32a7.64,7.64,0,0,0,2.28-.32v-2.4a11.57,11.57,0,0,1-1.8.16c-2.16,0-3.24-1-3.24-2.8V30.49Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.67d953016057e0608cc23d5454983d63.svg";
export { ForwardRef as ReactComponent };